import type { ActionContext, ActionTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { DeviceState } from "./state";
import type { DeviceCreate } from "@/interfaces/devices";
import { eventMonitor } from "@/api/eventMonitor";

// Pass in the state management context
type DevicesContext = ActionContext<DeviceState, State>;

export const actions: ActionTree<DeviceState, State> = {
  async actionGetDevices(context: DevicesContext): Promise<void> {
    try {
      const response = await eventMonitor.getDevices(
        context.rootState.main.token,
      );
      if (response) {
        context.commit("setDevices", response.data);
      }
    } catch (error) {
      console.log(error);
      context.commit(
        "main/addNotification",
        {
          content: "Error getting devices",
          color: "error",
        },
        { root: true },
      );
    }
  },
  async actionCreateDevice(
    context: DevicesContext,
    payload: DeviceCreate,
  ): Promise<void> {
    try {
      const response = await eventMonitor.createDevice(
        context.rootState.main.token,
        payload,
      );
      if (response) {
        await context.dispatch("actionGetDevices");
      }
    } catch (error) {
      console.log(`Add device failure`);
      console.log(error);
      context.commit(
        "main/addNotification",
        {
          content: "Failed to add device",
          color: "error",
        },
        { root: true },
      );
    }
  },
  async actionDeleteDevice(
    context: DevicesContext,
    payload: string,
  ): Promise<void> {
    try {
      const response = await eventMonitor.deleteDevice(
        context.rootState.main.token,
        payload,
      );
      if (response) {
        await context.dispatch("actionGetDevices");
      }
    } catch (error) {
      console.log(`Remove device failure`);
      console.log(error);
      context.commit(
        "main/addNotification",
        {
          content: "Failed to remove device",
          color: "error",
        },
        { root: true },
      );
    }
  },
};

const NS = "devices/";

export const dispatchActionGetDevices = (store: Store<State>) =>
  store.dispatch(`${NS}actionGetDevices`);
export const dispatchActionCreateDevice = (
  store: Store<State>,
  payload: DeviceCreate,
) => store.dispatch(`${NS}actionCreateDevice`, payload);
export const dispatchActionDeleteDevice = (
  store: Store<State>,
  payload: string,
) => store.dispatch(`${NS}actionDeleteDevice`, payload);
